import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IResourceModel } from '@/shared/model/briefing-widget.model';

@Component({})
export default class MakerthonCardComponent extends Vue {
  currentLanguage = localStorage.getItem('currentLanguage') !== undefined ? localStorage.getItem('currentLanguage') : 'en';

  randomImageEn = 'content/images/images_v3/event/go-event-241111-makerthon-card-A-eng.jpg';
  randomImageKo = 'content/images/images_v3/event/go-event-241111-makerthon-card-A-kor.png';
  // private language = this.$store.getters.language;

  private getRandomImage(images: string[]): string {
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  }

  clickEventBanner() {
    window.open(`${window.origin}/guide`);
  }
}
